import React, { useCallback } from 'react'
import { MenuItem } from '@mui/material';
import { CompanyMenuItemProps } from './CompanyMenuItem.props'

const CompanyMenuItem = ({
  handleDropDown,
  option,
  subMenuItem,
}: CompanyMenuItemProps) => {
  const handleClick = useCallback(() => {
    handleDropDown(option, subMenuItem)
  }, [handleDropDown, option, subMenuItem])

  return (
    <MenuItem
      key={option.id}
      id={`company-dropdown-item-${option.id}`}
      onClick={handleClick}
    >
      {option.title}
    </MenuItem>
  )
}

export default CompanyMenuItem
